// Placeholder — Phase 4 (Ride-Recording + Stats + Strava-Export).
export function RidePage() {
  return (
    <div className="absolute inset-0 p-4">
      <h1 className="text-xl font-semibold mb-3">Record ride</h1>
      <p className="text-white/60 text-sm">
        Coming in Phase 4: GPS tracking with pause detection, automatic
        uphill filtering for Strava, live stats.
      </p>
    </div>
  );
}
